import ReportsAdapter from './base';

export default class RubricCriteria extends ReportsAdapter {
  modelNamePlural = 'rubric-criteria';
}
